import { render, staticRenderFns } from "./send-bulk-product-payment-request-message-drawer.vue?vue&type=template&id=99b1661e&scoped=true&"
import script from "./send-bulk-product-payment-request-message-drawer.vue?vue&type=script&lang=ts&"
export * from "./send-bulk-product-payment-request-message-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./send-bulk-product-payment-request-message-drawer.vue?vue&type=style&index=0&id=99b1661e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b1661e",
  null
  
)

export default component.exports